interface Props {
  className?: string;
}

export const Telegram2Icon = ({ className }: Props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24 4C12.9516 4 4 12.9516 4 24C4 35.0484 12.9516 44 24 44C35.0484 44 44 35.0484 44 24C44 12.9516 35.0484 4 24 4ZM33.8226 17.7016L30.5403 33.1694C30.2984 34.2661 29.6452 34.5323 28.7339 34.0161L23.7339 30.3306L21.3226 32.6532C21.0565 32.9194 20.8306 33.1452 20.3145 33.1452L20.6694 28.0564L29.9355 19.6855C30.3387 19.3306 29.8468 19.129 29.3145 19.4839L17.8629 26.6935L12.9274 25.1532C11.8548 24.8145 11.8306 24.0806 13.1532 23.5645L32.4355 16.129C33.3306 15.8065 34.1129 16.3468 33.8226 17.7016Z"
      fill="currentColor"
    />
  </svg>
);
